import {inject} from '@angular/core';
import {CanActivateChildFn, CanActivateFn, Router, UrlTree} from '@angular/router';

import {RolesService} from './roles.service';

export const AccessLimitedGuard: CanActivateFn & CanActivateChildFn = (): boolean | UrlTree => {
  const rolesService = inject(RolesService);
  const router = inject(Router);

  if (rolesService.isAccessLimited()) {
    return router.createUrlTree(['/access-limited']);
  }
  return true;
};

